/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgressNotesFindAllResponse } from './ProgressNotesFindAllResponse';
import {
    ProgressNotesFindAllResponseFromJSON,
    ProgressNotesFindAllResponseFromJSONTyped,
    ProgressNotesFindAllResponseToJSON,
} from './ProgressNotesFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllResidentProgressNotes200Response
 */
export interface FindAllResidentProgressNotes200Response {
    /**
     * 
     * @type {ProgressNotesFindAllResponse}
     * @memberof FindAllResidentProgressNotes200Response
     */
    data?: ProgressNotesFindAllResponse;
}

/**
 * Check if a given object implements the FindAllResidentProgressNotes200Response interface.
 */
export function instanceOfFindAllResidentProgressNotes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllResidentProgressNotes200ResponseFromJSON(json: any): FindAllResidentProgressNotes200Response {
    return FindAllResidentProgressNotes200ResponseFromJSONTyped(json, false);
}

export function FindAllResidentProgressNotes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllResidentProgressNotes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ProgressNotesFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllResidentProgressNotes200ResponseToJSON(value?: FindAllResidentProgressNotes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ProgressNotesFindAllResponseToJSON(value.data),
    };
}

